import { render } from "./Projects.vue?vue&type=template&id=7426b2a5&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=7426b2a5&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\nicol\\Code\\portfolio_new\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7426b2a5"]])

export default __exports__